import React, { Suspense } from 'react';
import { LinearProgress, Typography } from '@mui/material';
import { useParams } from 'react-router';
import usePaginatedDocumentsManifest from '../../hooks/usePaginatedDocumentsManifest';
import { useDocumentAllPages } from '../../hooks/useDocumentAllPages';
import { useTheme } from '@mui/material';
import { DocumentDetailsParamTypes } from '../../../pages/DocumentDetailsPage';

const FullDocumentView = () => {
  const theme = useTheme();

  const { dpid, documentId } = useParams<DocumentDetailsParamTypes>();

  const { data: documentData, isLoading } = usePaginatedDocumentsManifest({
    limit: 1,
    dpId: dpid!,
    defaultPage: 0,
    includeId: documentId,
  });

  const docData = documentData?.results[0];
  const documentPages = useDocumentAllPages(docData?.pages, true);

  const isLoadingV2: boolean = documentPages.some((result: any) => result.isLoading);
  const isFetching: boolean = documentPages.some((result: any) => result.isFetching);

  if (!docData || isLoading || isLoadingV2 || isFetching) {
    return <LinearProgress />;
  }

  return (
    <div style={{ height: '81vh', overflowY: 'auto', width: '100%' }}>
      <Suspense fallback={<LinearProgress />}>
        {documentPages.map((page: any, index: number) => (
          <React.Fragment key={index}>
            <div
              style={{
                width: '100%',
                textAlign: 'right',
                position: 'sticky',
                top: 0,
                zIndex: 1,
                display: 'flex',
                justifyContent: 'flex-end',
                backgroundColor: theme.palette.custom.pageBackground,
              }}
            >
              {index > 0 && (
                <Typography
                  onClick={() => {
                    const prevPage = index;
                    const prevPageElement = document.getElementById(`page-${prevPage}`);
                    if (prevPageElement) {
                      prevPageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } else {
                      console.log(`No element found for page-${prevPage}`);
                    }
                  }}
                  style={{
                    cursor: 'pointer',
                    fontSize: '12px',
                    textAlign: 'right',
                    marginBottom: '4px',
                    paddingBottom: '2px',
                    marginRight: '8px',
                  }}
                >
                  Previous
                </Typography>
              )}
              {index < documentPages.length - 1 && (
                <Typography
                  onClick={() => {
                    const nextPage = index + 2;
                    const nextPageElement = document.getElementById(`page-${nextPage}`);
                    if (nextPageElement) {
                      nextPageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } else {
                      console.log(`No element found for page-${nextPage}`);
                    }
                  }}
                  style={{
                    cursor: 'pointer',
                    fontSize: '12px',
                    textAlign: 'right',
                    marginBottom: '4px',
                    paddingBottom: '2px',
                    marginRight: '8px',
                  }}
                >
                  Next
                </Typography>
              )}

              <Typography
                style={{
                  fontSize: '12px',
                  textAlign: 'right',
                  marginBottom: '4px',
                  paddingBottom: '2px',
                  // marginTop: '20px',
                }}
              >
                Page {index + 1}
              </Typography>
            </div>
            <img
              id={`page-${index + 1}`}
              src={page.data.file_temp_url}
              alt={`Page ${index + 1}`}
              style={{
                width: '100%',
                border: '1px solid #BDC3D2',
                boxSizing: 'border-box',
              }}
            />
            <div style={{ height: '20px' }} />
          </React.Fragment>
        ))}
      </Suspense>
    </div>
  );
};

export default FullDocumentView;
